import React from 'react';
import { Banknote, CreditCard, Receipt } from 'lucide-react';
import { COLORS, RADIUS, TYPOGRAPHY } from './design-tokens';

const PaymentItem = ({ icon: Icon, label, value }) => (
  <div
    style={{
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      alignItems: 'center',
      gap: '10px',
      padding: '8px',
      background: COLORS.card,
      border: `1px solid ${COLORS.line}`,
      borderRadius: '6px',
      marginBottom: '6px'
    }}
  >
    <div
      style={{
        width: '36px',
        height: '36px',
        borderRadius: '6px',
        background: COLORS.backgroundSecondary,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        color: COLORS.primary
      }}
    >
      <Icon size={18} strokeWidth={2} />
    </div>
    <div>
      <div style={{ fontSize: '10px', fontWeight: 600, color: COLORS.textSecondary, letterSpacing: '0.3px' }}>
        {label}
      </div>
      <div style={{ borderBottom: `1px solid ${COLORS.line}`, fontSize: '11px', color: COLORS.textPrimary, paddingBottom: '2px', marginTop: '2px' }}>
        {value || '_______________________'}
      </div>
    </div>
  </div>
);

const PaymentCard = ({ payment }) => {
  return (
    <div>
      <div
        style={{
          background: COLORS.primary,
          color: COLORS.card,
          padding: '8px 10px',
          borderRadius: `${RADIUS.card} ${RADIUS.card} 0 0`,
          ...TYPOGRAPHY.sectionTitle,
          letterSpacing: '1px',
          textAlign: 'center'
        }}
      >
        CONDIÇÕES DE PAGAMENTO
      </div>
      <div
        style={{
          background: COLORS.card,
          border: `1px solid ${COLORS.line}`,
          borderTop: 'none',
          borderRadius: `0 0 ${RADIUS.card} ${RADIUS.card}`,
          padding: '8px'
        }}
      >
        <PaymentItem icon={Banknote} label="Dinheiro / PIX" value={payment && payment.cash} />
        <PaymentItem icon={CreditCard} label="Cartão de Crédito" value={payment && payment.card} />
        <PaymentItem icon={Receipt} label="Boleto Bancário" value={payment && payment.boleto} />
        <PaymentItem icon={Receipt} label="Parcelamento" value={payment && payment.installments} />
      </div>
    </div>
  );
};

export default PaymentCard;
